import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const HistoryBtn = styled(Button)`
  overflow: hidden;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  position: relative;

  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;

  .img {
    width: 36px;
    height: 36px;
  }

  &.is-history {
    border: 0;
    background: none;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      border-radius: inherit;
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('36')};
    height: ${mixin.pxToVw('36')};
    border-radius: ${mixin.pxToVw('6')};

    .img {
      width: ${mixin.pxToVw('36')};
      height: ${mixin.pxToVw('36')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 44px;
    height: 44px;
    border-radius: 7px;

    .img {
      width: 44px;
      height: 44px;
    }
  }
`;
